<template>
  <div>
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="reload()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item label="申请编号：">
        <el-input v-model="dataForm.batchCode" size="mini" clearable type="text"></el-input>
      </el-form-item>
      <el-form-item prop="receiptCode" label="发票号：">
        <el-input v-model="dataForm.receiptCode" size="mini" clearable type="text"></el-input>
      </el-form-item>
      <el-form-item label="供应商名称：" v-if="$hasPermission('erp:receipt:query:sellerName')">
        <el-input v-model="dataForm.sellerName" size="mini" clearable type="text"></el-input>
      </el-form-item>
      <el-form-item label="申请人：">
        <el-input v-model="dataForm.creatorName" size="mini" clearable type="text"></el-input>
      </el-form-item>
      <el-form-item label="申请时间：">
        <el-date-picker
            v-model="queryDataRange"
            type="daterange"
            align="right"
            size="mini"
            value-format="yyyy-MM-dd"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="auditStatus" label="审核状态：">
        <dict-dropdown dictName="audit_status" v-model="dataForm.auditStatus" size="mini"></dict-dropdown>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="reload()" size="mini">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="doApplyReceipt()" size="mini" type="warning" v-if="$hasPermission('erp:receipt:apply')">
          创建账单
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="batchAudit(30)" size="mini" type="warning" v-if="$hasPermission('erp:receipt:audit')">
          批量驳回
        </el-button>
      </el-form-item>
    </el-form>
    <SweetTable ref="table" url="/erp/receipt/page" :before-table-binding="beforeTableBinding" api-version="v2"
                :query-form="dataForm" :summaries-column="['count','totalAmount']" :auto-load="false" :selection="true">
      <el-table-column prop="sellerName" label="销售方" align="center" header-align="center"
                       v-if="$hasPermission('erp:receipt:query:sellerName')"
                       :formatter="$c.companyNameFormatter" fixed="left" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="operateDate" label="开票时间" header-align="center"
                       align="center" width="160"></el-table-column>
      <el-table-column prop="code" label="发票号" align="center" header-align="center" >
        <template #default="{row}">
          <span v-if="row.code">{{ row.code }}</span>
          <span v-else>申请编号：{{ row.batchCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalAmount" label="发票金额" header-align="center"
                       align="center" width="160"></el-table-column>

      <el-table-column prop="creatorName" label="申请人" align="center" width="100" header-align="center">
      </el-table-column>
      <el-table-column prop="createDate" label="申请时间" align="center" header-align="center" width="160"
                       :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column prop="auditManName" label="审核人" align="center" width="100" header-align="center">
      </el-table-column>
      <el-table-column prop="auditStatus" label="审核状态" align="center" width="100" header-align="center">
        <template #default="{row}">
          <el-tag :type="$const.auditStatusColorMap[row.auditStatus]">{{ $const.auditStatus[row.auditStatus] }}</el-tag>
          <el-tooltip class="item" effect="dark" :content="row.auditTips" placement="top-start" v-if="row.auditTips">
            <i class="el-icon-warning"></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="auditTime" label="审核时间" align="center" :show-overflow-tooltip="true"
                       header-align="center" width="160"></el-table-column>
      <el-table-column label="操作" align="center" header-align="center" fixed="right" width="190">
        <template #default="{row}">
          <el-button type="text" icon="el-icon-edit-outline" @click="showDetailDialog(row)"
                     v-if="$hasPermission('erp:receipt:info')">详情
          </el-button>
          <el-button type="text" icon="el-icon-edit-outline" @click="doAudit(row,20)"
                     v-if="$hasPermission('erp:receipt:audit')&&row.auditStatus===10">通过
          </el-button>
          <el-button type="text" icon="el-icon-edit-outline" @click="doAudit(row,30)"
                     v-if="$hasPermission('erp:receipt:audit')&&row.auditStatus===10">拒绝
          </el-button>
          <el-button type="text" icon="el-icon-edit-outline" @click="cancelBill(row)"
                     v-if="$hasPermission('erp:receipt:cancel')&&(row.auditStatus===30||row.auditStatus===10)">撤回
          </el-button>
          <el-button type="text" icon="el-icon-edit-outline" @click="showDetailDialog(row)"
                     v-if="$hasPermission('erp:receipt:code')&&row.auditStatus===20&&!$c.str2bool(row.code)">设置发票号
          </el-button>
        </template>
      </el-table-column>
    </SweetTable>
    <CreateBillDialog ref="CreateBillDialog" @change="getDataList"></CreateBillDialog>
    <DetailDialog ref="DetailDialog"></DetailDialog>
  </div>
</template>

<script>
import DictDropdown from '@/components/DictDropdown'
import SweetTable from '@/mixins/SweetTable'
import DetailDialog from '@/views/modules/erp/receipt/detail-dialog.vue'
import CreateBillDialog from '@/views/modules/erp/receipt/create-bill-dialog.vue'

export default {
  name: 'receipt-table',
  mixins: [SweetTable],
  components: { CreateBillDialog, DetailDialog,DictDropdown },
  data () {
    return {
      dataForm: {
        batchCode: '',
        receiptCode: '',
        sellerName: '',
        creatorName: '',
        auditStatus: '',
        beginDate: '',
        endDate: '',
        receiptType: ''
      },
    }
  },
  props: {
    receiptType: {
      type: String,
      default: ''
    }
  },
  watch: {
    receiptType: {
      handler (val) {
        this.dataForm.receiptType = val
        this.reload()
      },
      immediate: true
    }
  },
  computed: {
    queryDataRange: {
      get () {
        return [this.dataForm.beginDate, this.dataForm.endDate]
      },
      set (val) {
        this.dataForm.beginDate = val[0]
        this.dataForm.endDate = val[1]
      }
    },
  },
  methods: {
    cancelBill (row) {
      let confirmMsg = `确认撤回账单【${row.batchCode}】的申请吗？`
      this.$confirm(confirmMsg, '提示').then(() => {
        this.$api2.post('/erp/receipt/bill/cancel', { id: row.id }).then(res => {
          this.$message.success('操作成功')
          this.getDataList()
        }).catch(err => {
          console.log(err)
        })
      })
    },
    batchAudit(status){
      let rows=this.$refs.table.dataListSelections
      if(this.$c.isArrayEmpty(rows)){
        return this.$message.error('请先选择需要操作的数据')
      }
      let confirmMsg = `是否批量${status === 20 ? '通过' : '拒绝'}【${rows.length}】条账单的申请？`
      this.$confirm(confirmMsg, '提示').then(() => {
        this.$api2.post('/erp/receipt/audit/batch', {ids:rows.map(row => row.id),status:status}).then(res => {
          this.$message.success('操作成功')
          this.getDataList()
        }).catch(err => {
          console.log(err)
        })
      })
    },
    doAudit (row, status) {
      let confirmMsg = `确认${status === 20 ? '通过' : '拒绝'}账单【${row.batchCode}】的申请吗？`
      this.$confirm(confirmMsg, '提示').then(() => {
        this.$api2.post('/erp/receipt/audit', { id: row.id, auditStatus: status }).then(res => {
          this.$message.success('操作成功')
          this.getDataList()
        }).catch(err => {
          console.log(err)
        })
      })
    },
    showDetailDialog (row) {
      this.$refs.DetailDialog.init(row.id)
    },
    doApplyReceipt () {
      this.$refs.CreateBillDialog.init()
    },
    beforeTableBinding (dataList) {
    }
  }
}
</script>

<style scoped>

</style>
